// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-info-box {
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: #5616ea25;
  border-radius: 10px;
  padding: 14px;
  line-height: 1.45;
  border-left: 5px solid #5616ea;
}

.report-info-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.report-info-box p {
  margin: 0;
}

.report-info-icon {
  font-size: 32px;
  color: #5616ea;
  flex-shrink: 0;
}

.next-report-info-box {
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: #059d1125;
  border-radius: 10px;
  padding: 10px;
  line-height: 1.45;
  border-left: 5px solid #059d11;
}

.next-report-info-box p {
  margin: 0;
  font-size: 14px;
}

.next-report-info-icon {
  font-size: 20px;
  color: #059d11;
  flex-shrink: 0;
}

.report-warning-inner {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #fff9e1;
  border-left: 4px solid #ffc107;
  border-radius: 8px;
  padding: 8px 10px;
  margin-bottom: 12px;
}

.report-warning-inner p {
  margin: 0;
  color: #554002;
  font-size: 14px;
}

.report-warning-icon {
  font-size: 20px;
  color: #ffc107;
  flex-shrink: 0;
}

.reporting-parent {
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 20px;
  max-width: 1000px;
  gap: 16px;
  margin-top: 30px;
}

.reporting-parent h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 0px;
  color: #222;
}

.report-control-group {
  display: flex;
  flex-direction: column;
  gap: 0px;
}

.report-section-title {
  margin: 0;
}

.report-weekdays-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(120px, 1fr));
  gap: 8px 14px;
  max-width: 560px;
}

.report-weekday-item {
  display: flex;
  align-items: center;
  gap: 6px;
  -webkit-user-select: none;
          user-select: none;
}

.report-unsaved-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff9e1;
  border-left: 4px solid #ffc107;
  border-radius: 8px;
  padding: 8px 10px;
  color: #554002;
}

.report-unsaved-icon {
  font-size: 18px;
}

.report-actions {
  display: flex;
  gap: 10px;
  margin-top: 4px;
}

.report-save-btn {
  padding: 10px 16px;
  border: none;
  outline: none;
  background-color: #5616ea;
  color: white;
  font-weight: 600;
  border-radius: 8px;
  transition: transform 0.2s ease;
}

.report-save-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  cursor: pointer;
}

.report-save-btn:disabled {
  background-color: #b9a6ff;
  cursor: not-allowed;
}

.report-discard-btn {
  padding: 10px 16px;
  border: 1px solid #d2d2d2;
  outline: none;
  background-color: white;
  color: #434343;
  font-weight: 600;
  border-radius: 8px;
  transition: transform 0.2s ease, background-color 0.2s ease;
}

.report-discard-btn:hover {
  transform: translateY(-1px);
  background-color: #f6f6f6;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/reporting.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,2DAA2D;AAC7D;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,eAAe;AACjB","sourcesContent":[".report-info-box {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n  background-color: #5616ea25;\r\n  border-radius: 10px;\r\n  padding: 14px;\r\n  line-height: 1.45;\r\n  border-left: 5px solid #5616ea;\r\n}\r\n\r\n.report-info-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.report-info-box p {\r\n  margin: 0;\r\n}\r\n\r\n.report-info-icon {\r\n  font-size: 32px;\r\n  color: #5616ea;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.next-report-info-box {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n  background-color: #059d1125;\r\n  border-radius: 10px;\r\n  padding: 10px;\r\n  line-height: 1.45;\r\n  border-left: 5px solid #059d11;\r\n}\r\n\r\n.next-report-info-box p {\r\n  margin: 0;\r\n  font-size: 14px;\r\n}\r\n\r\n.next-report-info-icon {\r\n  font-size: 20px;\r\n  color: #059d11;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.report-warning-inner {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  background-color: #fff9e1;\r\n  border-left: 4px solid #ffc107;\r\n  border-radius: 8px;\r\n  padding: 8px 10px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.report-warning-inner p {\r\n  margin: 0;\r\n  color: #554002;\r\n  font-size: 14px;\r\n}\r\n\r\n.report-warning-icon {\r\n  font-size: 20px;\r\n  color: #ffc107;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.reporting-parent {\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: rgba(255, 255, 255, 0.75);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 10px;\r\n  padding: 20px;\r\n  max-width: 1000px;\r\n  gap: 16px;\r\n  margin-top: 30px;\r\n}\r\n\r\n.reporting-parent h3 {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  margin-bottom: 0px;\r\n  color: #222;\r\n}\r\n\r\n.report-control-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0px;\r\n}\r\n\r\n.report-section-title {\r\n  margin: 0;\r\n}\r\n\r\n.report-weekdays-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(120px, 1fr));\r\n  gap: 8px 14px;\r\n  max-width: 560px;\r\n}\r\n\r\n.report-weekday-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  user-select: none;\r\n}\r\n\r\n.report-unsaved-banner {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  background: #fff9e1;\r\n  border-left: 4px solid #ffc107;\r\n  border-radius: 8px;\r\n  padding: 8px 10px;\r\n  color: #554002;\r\n}\r\n\r\n.report-unsaved-icon {\r\n  font-size: 18px;\r\n}\r\n\r\n.report-actions {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-top: 4px;\r\n}\r\n\r\n.report-save-btn {\r\n  padding: 10px 16px;\r\n  border: none;\r\n  outline: none;\r\n  background-color: #5616ea;\r\n  color: white;\r\n  font-weight: 600;\r\n  border-radius: 8px;\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.report-save-btn:hover:not(:disabled) {\r\n  transform: translateY(-1px);\r\n  cursor: pointer;\r\n}\r\n\r\n.report-save-btn:disabled {\r\n  background-color: #b9a6ff;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.report-discard-btn {\r\n  padding: 10px 16px;\r\n  border: 1px solid #d2d2d2;\r\n  outline: none;\r\n  background-color: white;\r\n  color: #434343;\r\n  font-weight: 600;\r\n  border-radius: 8px;\r\n  transition: transform 0.2s ease, background-color 0.2s ease;\r\n}\r\n\r\n.report-discard-btn:hover {\r\n  transform: translateY(-1px);\r\n  background-color: #f6f6f6;\r\n  cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
